var map = {
	"./amostras_medicamentos_bg.webp": "b10c",
	"./documentos_digitais_bg.webp": "af27",
	"./faturas_bg.webp": "976a",
	"./hub_solucoes.webp": "d67c",
	"./repositorio_unico_bg.webp": "749b",
	"./representantes-farmaceuticos-digitais-o-futuro-da-industria-baixe-o-ebook.webp": "a872",
	"./video_interativo_bg.webp": "d1fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e32";